import { storeToRefs } from "pinia";

import { useTariffStore, useUserStore } from "@/entities";

import { useSidebarStore } from "../model/useSidebarStore";

// Разделы Магазин/Мастерская доступны только при наличии модуля в тарифе.
// Бэк отдаёт их пункты меню всем директорам, поэтому доступ определяем по
// активному тарифу: нет модуля — пункт показывается заблокированным с
// подсказкой «недоступно на вашем тарифе» (shouldDisplayWithoutAccess).
const TARIFF_GATED_MENU = {
    MENU_STOCK: "haveAccessStore",
    MENU_REPAIR: "haveAccessRepairService",
};

// Меню с бэка приходит деревом — доступ проверяем и по корню, и по детям
// (пункты фронта могут ссылаться на дочерние const из БД).
const flattenMenu = (items) =>
    items.flatMap((item) => [item, ...flattenMenu(item.children ?? [])]);

// Права на разделы меню: пункт проверяется по своей константе, группа — по
// вложенным пунктам. Композабл общий для корня меню и для вложенных списков.
export const useMenuAccess = () => {
    const { menuLinks } = storeToRefs(useSidebarStore());
    const { tariff } = storeToRefs(useTariffStore());
    const userStore = useUserStore();

    const checkConstAccess = (desiredConst) => {
        if (!menuLinks.value) return false;

        const tariffFlag = TARIFF_GATED_MENU[desiredConst];

        if (tariffFlag && !tariff.value?.[tariffFlag]) return false;

        return flattenMenu(menuLinks.value).some((menuLink) => {
            return menuLink.const === desiredConst;
        });
    };

    // Своей константы у группы нет: она открыта, пока в ней остаётся хотя бы
    // один видимый пункт, иначе заголовок висел бы над пустым списком.
    // Заблокированные пункты с подсказкой про тариф директор тоже видит.
    function checkLinkAccess(key, linkMeta) {
        const children = Object.entries(linkMeta?.children ?? {});

        if (children.length > 0) {
            return children.some(([childKey, childMeta]) => {
                return (
                    checkLinkAccess(childKey, childMeta) ||
                    (userStore.isDirector &&
                        Boolean(childMeta.shouldDisplayWithoutAccess))
                );
            });
        }

        return checkConstAccess(linkMeta?.accessConst ?? key);
    }

    return { checkLinkAccess };
};
